import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from '../../../../vendor_core/core/src/model/BuyFeatureModel';
import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import { ICondition } from "../../../../vendor_core/core/src/states/State";
import VendorModel from '../../../../vendor_core/server/model/VendorModel';

export class BBHasBigWinCondition implements ICondition {
    public check(): boolean {
        return this.hasSpecificBigWin() && SpinModel.cascadeIndex == SpinModel.cascades.length
    }

    private hasSpecificBigWin(): boolean {
        return this.getWinRatio() > (GameModel.gameConfig as any).bigWinRatioLevels[0];
    }

    private getWinRatio() {

        let totalBet = BetModel.totalBet;

        if (BuyFeatureModel.isInBuyFeatureFreeSpins) {
            totalBet = BuyFeatureModel.getBet();
        }

        return SpinModel.currentWin / totalBet;
    }
}
